import { PageHero, SectionHead, Reveal, Card, usePageMeta } from "@/components/primitives";
import { InnovationGrid, MoatSection, FinalCTA } from "@/components/blocks2";
import { INNOVATIONS } from "@/lib/data";

const FOCUS_AREAS = [
  { title: "Fraud & Risk Intelligence", body: "Research into real-time fraud detection, behavioural analytics and device intelligence tuned for India's transaction patterns." },
  { title: "Privacy-Preserving Finance", body: "Architectures that deliver intelligent experiences while minimising the personal data they require." },
  { title: "Compliance-by-Design", body: "Regulatory logic encoded into workflows — audit trails, KYC/AML checks and reporting as native capabilities." },
  { title: "Intelligent Onboarding", body: "Identity verification and onboarding journeys designed to be fast for genuine users and hostile to misuse." },
];

export default function Innovation() {
  usePageMeta(
    "TimePe Innovation | AI, Fraud Intelligence & Bharat-First DeepTech",
    "Innovation is TimePe's operating system: fraud and risk intelligence, privacy-preserving finance, compliance-by-design and Bharat-first technology."
  );
  return (
    <>
      <PageHero
        eyebrow="Innovation"
        lines={["Innovation Is", "Our Operating System."]}
        lead="We treat fraud intelligence, privacy and compliance as research problems worth solving deeply — not features to ship quickly."
      />

      <section className="border-b border-line py-24 sm:py-32" data-testid="innovation-focus">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-8">
          <SectionHead eyebrow="Focus Areas" title="Where We Go Deep" />
          <div className="mt-14 grid gap-5 sm:grid-cols-2">
            {FOCUS_AREAS.map((f, i) => (
              <Reveal key={f.title} delay={i * 0.07}>
                <Card testid={`focus-card-${i}`} className="h-full p-8">
                  <p className="font-mono text-xs text-electric">{String(i + 1).padStart(2, "0")}</p>
                  <h3 className="mt-4 font-display text-xl font-semibold text-mist">{f.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-mute">{f.body}</p>
                </Card>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <InnovationGrid chapter="The Agenda" cta={false} />
      <MoatSection />
      <FinalCTA />
    </>
  );
}
